package diana.soleil.design.iraniancanadienbazzar.core.model

/**
 * One hidden item waiting for the owner's go-ahead in Admin → New content: news, jokes, recipes and
 * facts land hidden (`visible:false`) — from the daily AI content job or a manual import — and only
 * reach users once published here. Flattened to what a review card needs, whatever the kind.
 */
data class PendingContentItem(
    val kind: PendingContentKind,
    val id: String,
    /** News/recipe title; null for jokes and facts, which are just their text. */
    val title: LocalizedText? = null,
    val text: LocalizedText = LocalizedText(),
    val imageUrl: String? = null,
    /** Source article (news) — the reviewer checks the facts against it. */
    val linkUrl: String? = null,
)

/** Firestore collection per kind: `news`, `jokes`, `recipes`, `facts`. */
enum class PendingContentKind(val collection: String) {
    News("news"),
    Joke("jokes"),
    Recipe("recipes"),
    Fact("facts"),
}
